import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";




const insertClinicDomain = (fields) => {
    var data = {
        "regionId": fields.regionName.id,
        "clinicDomainName": fields.clinicDomainName,
        "dbSource": fields.dbSource,
        "dbName": fields.dbName,
        "dbUser": fields.dbUser,
        "dbPassword": fields.dbPassword,
        "isDefault": fields.isDefault
    }
    return ApiHelper.postRequest(ApiUrls.INSERT_CLINIC_DOMAIN, data,);
};

const getClinicDomains = () => {
    return ApiHelper.getRequest(ApiUrls.GET_CLINIC_DOMAINS + "isActive=" + true);
};


export const ClinicDomainService = {
    insertClinicDomain,
    getClinicDomains
}